module.exports = __webpack_public_path__ + "media/assets/images/curation/gooded-38b5d0957c674f93bcdfb32a3f9eebf9.svg";